import { http } from "@/network";

export interface NocoListMeta {
  count?: number;
  page?: number;
  pageSize?: number;
  totalPage?: number;
}

export interface NocoListResult<T> {
  data: T[];
  meta?: NocoListMeta;
}

export function buildIncludesFilter(field: string, keyword?: string) {
  const kw = (keyword ?? "").trim();
  if (!kw) return undefined;
  return { $and: [{ [field]: { $includes: kw } }] };
}

export function listTable<T>(
  table: string,
  params: {
    page: number;
    pageSize: number;
    tree?: boolean;
    filter?: unknown;
    [key: string]: unknown;
  },
): Promise<NocoListResult<T>> {
  const normalizedParams = { ...params } as Record<string, unknown>;

  if (!("sort[]" in normalizedParams) && !("sort" in normalizedParams)) {
    normalizedParams["sort[]"] = ["-id"];
  } else if ("sort[]" in normalizedParams) {
    const v = normalizedParams["sort[]"];
    if (typeof v === "string") normalizedParams["sort[]"] = [v];
  }

  if (normalizedParams.filter && typeof normalizedParams.filter === "object") {
    normalizedParams.filter = JSON.stringify(normalizedParams.filter);
  }
  return http.get<NocoListResult<T>>(`/${table}:list`, {
    params: normalizedParams,
  });
}

export function createTable<T>(
  table: string,
  values: Record<string, unknown>,
  query: string,
): Promise<{ data: T }> {
  return http.post<{ data: T }>(`/${table}:create${query || ""}`, values);
}

export function deleteTable(
  table: string,
  id: string | number,
): Promise<unknown> {
  return http.post<unknown, Record<string, never>>(
    `/${table}:delete`,
    {},
    { params: { filterByTk: id } },
  );
}

export function destroyTable(
  table: string,
  ids: Array<string | number> | string | number,
): Promise<unknown> {
  const list = Array.isArray(ids) ? ids : [ids];
  return http.post<unknown, Record<string, never>>(
    `/${table}:destroy`,
    {},
    {
      params: { filterByTk: JSON.stringify(list) },
    },
  );
}

export function updateTable<T>(
  table: string,
  id: string | number,
  values: Record<string, unknown>,
): Promise<{ data: T }> {
  return http.post<{ data: T }>(`/${table}:update`, values, {
    params: { filterByTk: id },
  });
}

export function destroyTableByObject(
  table: string,
  axiosParams: Record<string, unknown>,
): Promise<unknown> {
  return http.post<unknown, Record<string, never>>(
    `/${table}:destroy`,
    {},
    { params: axiosParams },
  );
}
